import { Button, Modal, Radio, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { STORE_FILTER_TYPE } from "../../common/constant";
import { common } from "../../services";
import "./style.scss";

const FilterStoreAgencyModal = (props: any) => {
  const { getFilters, getStoresWithFilters } = props;
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [idDistrict, setIdDistrict] = useState<number>();
  const [isAgency, setIsAgency] = useState(-1);
  const [cities, setCities] = useState<any>([]);
  const [districts, setDistricts] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    await getStoresWithFilters();
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (cities.length === 0 && isModalVisible) {
      setLoading(true);

      common.getDistrictStore((data, err) => {
        if (data) {
          setCities(data.docs);
          setLoading(false);
        }
      });
    }
  }, [isModalVisible]);

  const handleChangeCity = (value: number) => {
    const findCity = cities.find((city: any) => city.id === value);

    if (findCity) {
      setDistricts(findCity.data);
    }
  };

  const handleChangeDistrict = async (value: number) => {
    setIdDistrict(value);
    await getFilters(value, isAgency);
  };

  return (
    <div style={{}}>
      <Button onClick={showModal}>{t("store_filter_title")}</Button>
      <Modal
        title={t("store_filter_title")}
        visible={isModalVisible}
        onOk={handleOk}
        okText={t("btn_apply")}
        okButtonProps={{ disabled: !idDistrict ? true : false }}
        onCancel={handleCancel}
        cancelText={t("btn_no")}>
        {/* <div className="filter-store-container">
          <div className="filter-type-store"> */}
        <div className="nearby-store-filter--mobile">
          <Radio.Group
            className="nearby-store-filter__radio-btn radio-group"
            defaultValue={-1}
            buttonStyle="solid"
            onChange={(e) => {
              setIsAgency(e.target.value);
              // getFilters(idDistrict, e.target.value);
            }}>
            {STORE_FILTER_TYPE.map((item: any) => (
              <Radio.Button
                key={item.value}
                value={item.value}
                className="sub-content">
                {t(item.label)}
              </Radio.Button>
            ))}
          </Radio.Group>

          <div className="nearby-store-filter__location filter-city-district">
            <Select
              className="select-item sub-content"
              showSearch
              placeholder={t("field_city")}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
              loading={loading}
              onChange={handleChangeCity}
              listHeight={190}>
              {cities.map((city: any) => (
                <Select.Option
                  key={city.id}
                  value={city.id}
                  className="sub-content">
                  {city.name}
                </Select.Option>
              ))}
            </Select>

            <Select
              className="select-item sub-content"
              showSearch
              placeholder={t("field_district")}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
              onChange={handleChangeDistrict}
              listHeight={190}>
              {districts?.map((district: any) => (
                <Select.Option
                  key={district.id}
                  value={district.id}
                  className="sub-content">
                  {district.name}
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
        {/* </div>
        </div> */}
      </Modal>
    </div>
  );
};

export default FilterStoreAgencyModal;
